export const PAYMENT_AMOUNT = [
  { label: '100_000', value: 100_000 },
  { label: '1_000_000', value: 1_000_000 },
  { label: '10_000_000', value: 10_000_000 },
];
